import { flagFactory } from '../icon';
import Svg from './fr.svg';

export default flagFactory(Svg);
